const zIndex = 9999;
export {
  zIndex
};
//# sourceMappingURL=zIndex.js.map
